import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  Page404,
  PageSix,
  PageFour,
  PageFive,
  LoginPage,
  PageAnalytics,
  PageIssues,
  PageRules,
  PageJobs,
  PageReports,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        { path: 'dashboard', element: <PageAnalytics /> },
        { path: 'issues', element: <PageIssues /> },
        { path: 'rules', element: <PageRules /> },
        { path: 'jobs', element: <PageJobs /> },
        { path: 'reports', element: <PageReports /> },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/user/four" replace />, index: true },
            { path: 'four', element: <PageFour /> },
            { path: 'five', element: <PageFive /> },
            { path: 'six', element: <PageSix /> },
          ],
        },

      ],
    },
    {
      path: '/dashboard1',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'analytics', element: <PageAnalytics /> },
        { path: 'issues', element: <PageIssues /> },
        { path: 'rules', element: <PageRules /> },
        { path: 'jobs', element: <PageJobs /> },
        { path: 'reports', element: <PageReports /> },
        
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/four" replace />, index: true },
            { path: 'four', element: <PageFour /> },
            { path: 'five', element: <PageFive /> },
            { path: 'six', element: <PageSix /> },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
